import React, { useState, useEffect } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import axiosInstance from "../Help/AxiosLogicInstance";
import { toast } from "react-toastify/unstyled";
import Signup from "./Signup";
import SignIn from "./SignIn";
import LazyImg from "./LazyImg";
import { HashLink } from "react-router-hash-link";
import ResetPasswordModal from "./ResetPassword";
const Header = ({ activeModal, setActiveModal }) => {
  // State variables remain unchanged
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showResources, setShowResources] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [showSignIn, setShowSignIn] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showPrograms, setShowPrograms] = useState(false);
  const [showSummit, setShowSummit] = useState(false);
  // const [activeModal, setActiveModal] = useState(null);

  let token = localStorage.getItem("token");
  let studentId = localStorage.getItem("StudentId"); // Make sure to store studentId on login
  const navigate = useNavigate();

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
    setShowSignIn(false);
    setShowSignup(false);
    window.dispatchEvent(new Event("auth-change")); // <-- This triggers update in all components
  };
  const closeDropdown = () => setIsDropdownOpen(false);

  const handleResetPassword = () => {
    navigate("/changepassword");
  };
  // Update the handleLogout function
  const handleLogout = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    const token = localStorage.getItem("token");
    const studentId = localStorage.getItem("StudentId");
    try {
      await axiosInstance.post("api/Student/StudentLogout", {
        StudentId: studentId,
        Token: token,
      });
      toast.success("Logout successful!");
    } catch (err) {
      toast.error("Logout failed. Please try again.");
    }
    localStorage.removeItem("token");
    localStorage.removeItem("StudentId");
    setIsAuthenticated(false);
    setIsDropdownOpen(false);
    navigate("/");
    window.dispatchEvent(new Event("auth-change"));
  };
  // Update the useEffect to listen for storage events
  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem("token");
      setIsAuthenticated(!!token);
    };

    checkAuth();

    const handleAuthChange = () => {
      checkAuth();
    };

    window.addEventListener("storage", handleAuthChange);
    window.addEventListener("auth-change", handleAuthChange);

    return () => {
      window.removeEventListener("storage", handleAuthChange);
      window.removeEventListener("auth-change", handleAuthChange);
    };
  }, []);
  return (
    <header
      className="ul-header"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 1020,
        background: "#009e4f",
      }}
    >
      <div className="ul-header-bottom to-be-sticky">
        <div className="ul-header-bottom-wrapper ul-header-container">
          <div className="logo-container text-center">
            <Link to="/" className="d-inline-block">
              <LazyImg
                src="/assets/img/Medengage-whiteLogo-3 1.png"
                alt="MedEngage logo"
                className="logo"
                loading="eager"
              />
            </Link>
            {/* <div className="csr-tagline mt-2">
              A CSR initiative by Metropolis Healthcare Limited
            </div> */}
          </div>

          <div className="ul-header-nav-wrapper">
            <nav className="ul-header-nav">
              <Link
                to="/"
                className="text-light"
                onClick={(e) => {
                  if (window.location.pathname === "/") {
                    e.preventDefault();
                    const aboutSection = document.getElementById("home");
                    if (aboutSection) {
                      aboutSection.scrollIntoView({ behavior: "smooth" });
                    }
                  }
                }}
              >
                Home{" "}
              </Link>

              <HashLink
                smooth
                to="/#about"
                scroll={(el) => {
                  const yOffset = -80; // height of your fixed header
                  const y =
                    el.getBoundingClientRect().top +
                    window.pageYOffset +
                    yOffset;
                  window.scrollTo({ top: y, behavior: "smooth" });
                }}
                onClick={() => setIsOpen(false)}
              >
                <span>About Us</span>
              </HashLink>
              <div className="has-sub-menu">
                <a role="button">Programs</a>
                <div className="ul-header-submenu">
                  <ul>
                    <li>
                      <Link to="/scholarship-program">Scholarship Program</Link>
                    </li>
                    <li>
                      <Link to="/observership-program">
                        Observership Program
                      </Link>
                    </li>
                    <li>
                      <Link to="/laboratory-tour">Laboratory Tour</Link>
                    </li>
                    <li>
                      <Link to="/building-knowledge-community">
                        Building Knowledge Community
                      </Link>
                    </li>
                    <li>
                      <Link to="/academic-research-support">
                        Academic Research Support
                      </Link>
                    </li>
                    <li>
                      <Link to="/internship-program">
                        Internship Research Program
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="has-sub-menu">
                <a role="button">Summit</a>
                <div className="ul-header-submenu">
                  <ul>
                    <li>
                      <Link to="/summit-2018">Med-Engage summit 18-19</Link>
                    </li>
                    <li>
                      <Link to="/summit-2021">Med-Engage summit 20-21</Link>
                    </li>
                    <li>
                      <Link to="/summit-2022">Med-Engage summit 21-22</Link>
                    </li>
                    <li>
                      <Link to="/summit-2023">Med-Engage summit 22-23</Link>
                    </li>
                    <li>
                      <Link to="/summit-2024">Med-Engage summit 23-24</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="has-sub-menu">
                <a role="button">Resources</a>
                <div className="ul-header-submenu">
                  <ul>
                    <li>
                      <Link to="/stories">Stories</Link>
                    </li>
                    <li>
                      <Link to="/testimonials">Testimonials</Link>
                    </li>
                  </ul>
                </div>
              </div>

              <NavLink to="/contact-us">Contact</NavLink>
              {isAuthenticated && (
                <div className="has-sub-menu">
                  <a role="button">My Account</a>
                  <div className="ul-header-submenu">
                    <ul>
                      <li>
                        <Link
                          to="/profile/"
                          className="d-flex align-items-center"
                        >
                          <i className="fa fa-user me-2 text-success"></i>
                          Profile
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleResetPassword();
                          }}
                          className="d-flex align-items-center"
                        >
                          <i className="fa fa-key me-2 text-success"></i>
                          Reset Password
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/"
                          onClick={handleLogout}
                          className="d-flex align-items-center"
                        >
                          <i className="fa fa-sign-out me-2 text-success"></i>
                          Logout
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </nav>
          </div>
          <div className="ul-header-actions d-lg-none position-relative">
            {isAuthenticated ? (
              // Authenticated: show user icon with dropdown
              <>
                <button
                  type="button"
                  className="btn-user-icon"
                  title="Account"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                  <i className="fa fa-user fa-lg text-success"></i>
                </button>

                {isDropdownOpen && (
                  <div className="mobile-dropdown">
                    <ul className="dropdown-menu show w-100 m-0 p-0">
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/profile/"
                          onClick={closeDropdown} // ✅ close dropdown on click
                        >
                          Profile
                        </Link>
                      </li>
                      <li>
                        <hr className="dropdown-divider" />
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleResetPassword();
                            closeDropdown(); // ✅ close dropdown after action
                          }}
                        >
                          Reset Password
                        </Link>
                      </li>
                      <li>
                        <hr className="dropdown-divider" />
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/"
                          onClick={() => {
                            handleLogout();
                            closeDropdown(); // ✅ close dropdown on logout
                          }}
                        >
                          Logout
                        </Link>
                      </li>
                    </ul>
                  </div>
                )}
              </>
            ) : (
              // Not authenticated: show Sign In and Sign Up icons with text below
              <div className="d-flex gap-2 justify-content-center align-items-center mt-2">
                {/* Sign In */}
                <div
                  className="d-flex flex-column align-items-center justify-content-center text-center"
                  role="button"
                  onClick={() => setActiveModal("signIn")}
                >
                  <i className="fa fa-sign-in fa-lg text-light"></i>
                  <span className="text-light small">Sign In</span>
                </div>

                {/* Sign Up */}
                <div
                  className="d-flex flex-column align-items-center justify-content-center text-center"
                  role="button"
                  onClick={() => setActiveModal("signUp")}
                >
                  <i className="fa fa-user-plus fa-lg text-light"></i>
                  <span className="text-light small">Sign Up</span>
                </div>
              </div>
            )}
          </div>

          <div className="ul-header-actions d-flex align-items-center gap-2">
            {!isAuthenticated && (
              <div className="d-none d-lg-flex gap-2">
                {" "}
                {/* hidden on mobile & tablet, shows on lg+ */}
                <button
                  type="button"
                  className="btn btn-light text-success px-4 py-2 rounded-3"
                  onClick={() => setActiveModal("signIn")}
                >
                  Sign in
                </button>
                <button
                  type="button"
                  className="btn btn-outline-light px-4 py-2 rounded-3"
                  onClick={() => setActiveModal("signUp")}
                >
                  Sign up
                </button>
                {/* SignIn modal */}
                <SignIn
                  show={activeModal === "signIn"}
                  handleClose={() => setActiveModal(null)}
                  openSignUp={() => setActiveModal("signUp")}
                  openReset={() => setActiveModal("reset")}
                  onLoginSuccess={handleLoginSuccess}
                />
                <Signup
                  show={showSignup}
                  onClose={() => setShowSignup(false)}
                  onSignupSuccess={handleLoginSuccess}
                  openSignIn={() => {
                    setShowSignup(false); // close SignUp
                    setShowSignIn(true); // open SignIn
                  }}
                />
              </div>
            )}
          </div>
        </div>
        {/* Mobile Menu Icon (no button background) */}
        <span
          className="ul-header-sidebar-opener d-lg-none text-white"
          onClick={() => setIsOpen(!isOpen)}
          style={{ cursor: "pointer" }}
        >
          <i
            className={`fa ${isOpen ? "fa-times" : "fa-bars"} fa-lg`}
            aria-hidden="true"
          ></i>
        </span>

        {/* Mobile Sidebar */}
        <div className={`mobile-sidebar ${isOpen ? "open" : ""} d-lg-none`}>
          <nav className="mobile-nav d-flex flex-column p-0">
            {/* Navigation Items Container */}
            <div className="nav-items-container p-3">
              {/* Home Link */}
              <Link
                to="/"
                onClick={() => setIsOpen(false)}
                className="mobile-nav-link d-flex align-items-center justify-content-start gap-3 p-3 mb-2 rounded-3 text-decoration-none"
              >
                <span className="fw-medium">Home</span>
              </Link>

              {/* About Link */}

              <HashLink
                to="/#about" // this is your home page route + section ID
                onClick={() => setIsOpen(false)}
                scroll={(el) => {
                  const yOffset = -80; // adjust to your fixed header height
                  const y =
                    el.getBoundingClientRect().top +
                    window.pageYOffset +
                    yOffset;
                  window.scrollTo({ top: y, behavior: "smooth" });
                }}
                className="mobile-nav-link d-flex align-items-center justify-content-start gap-3 p-3 mb-2 rounded-3 text-decoration-none"
              >
                <span className="fw-medium">About Us</span>
              </HashLink>

              {/* Programs Collapsible */}
              <div className="mobile-submenu mb-3">
                <button
                  className={`submenu-btn w-100 text-start d-flex justify-content-between align-items-center p-3 rounded-3 border-0 ${
                    showPrograms ? "active" : ""
                  }`}
                  onClick={() => setShowPrograms(!showPrograms)}
                >
                  <span className="fw-medium">Programs</span>

                  <i
                    className={`fa ${
                      showPrograms ? "fa-chevron-up" : "fa-chevron-down"
                    }`}
                    style={{
                      transition: "transform 0.3s ease",
                      transform: showPrograms
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    }}
                  ></i>
                </button>

                {/* Summit Submenu */}
                <div
                  className="submenu-container overflow-hidden"
                  style={{
                    maxHeight: showPrograms ? "300px" : "0",
                    transition:
                      "max-height 0.4s ease-in-out, opacity 0.3s ease",
                    opacity: showPrograms ? 1 : 0,
                  }}
                >
                  <div className="submenu-items pe-2 ps-3 pt-2">
                    {[
                      {
                        to: "/scholarship-program",
                        text: "Scholarship Program",
                      },
                      {
                        to: "/observership-program",
                        text: "Observership Program",
                      },
                      { to: "/laboratory-tour", text: "Laboratory Tour" },
                      {
                        to: "/building-knowledge-community",
                        text: "Building Knowledge Community",
                      },
                      {
                        to: "/academic-research-support",
                        text: "Academic Research Support",
                      },
                      {
                        to: "/internship-program",
                        text: "Internship Research Program",
                      },
                    ].map((item, index) => (
                      <Link
                        key={index}
                        to={item.to}
                        onClick={() => setIsOpen(false)}
                        className="submenu-link d-block text-start py-2 rounded-2 text-decoration-none"
                      >
                        {item.text}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>

              {/* Summit Collapsible */}
              <div className="mobile-submenu mb-3">
                <button
                  className={`submenu-btn w-100 text-start d-flex justify-content-between align-items-center p-3 rounded-3 border-0 ${
                    showSummit ? "active" : ""
                  }`}
                  onClick={() => setShowSummit(!showSummit)}
                >
                  <span className="fw-medium">Summit</span>

                  <i
                    className={`fa ${
                      showSummit ? "fa-chevron-up" : "fa-chevron-down"
                    }`}
                    style={{
                      transition: "transform 0.3s ease",
                      transform: showSummit ? "rotate(180deg)" : "rotate(0deg)",
                    }}
                  ></i>
                </button>

                {/* Summit Submenu */}
                <div
                  className="submenu-container overflow-hidden"
                  style={{
                    maxHeight: showSummit ? "300px" : "0",
                    transition:
                      "max-height 0.4s ease-in-out, opacity 0.3s ease",
                    opacity: showSummit ? 1 : 0,
                  }}
                >
                  <div className="submenu-items pe-2 ps-3 pt-2">
                    {[
                      { to: "/summit-2018", text: "Summit 18-19" },
                      { to: "/summit-2021", text: "Summit 20-21" },
                      { to: "/summit-2022", text: "Summit 21-22" },
                      { to: "/summit-2023", text: "Summit 22-23" },
                      { to: "/summit-2024", text: "Summit 23-24" },
                    ].map((item, index) => (
                      <Link
                        key={index}
                        to={item.to}
                        onClick={() => setIsOpen(false)}
                        className="submenu-link d-block text-start py-2 rounded-2 text-decoration-none"
                      >
                        {item.text}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
              <div className="mobile-submenu mb-3">
                <button
                  className={`submenu-btn w-100 text-start d-flex justify-content-between align-items-center p-3 rounded-3 border-0 ${
                    showResources ? "active" : ""
                  }`}
                  onClick={() => setShowResources(!showResources)}
                >
                  <span className="fw-medium">Resources</span>

                  <i
                    className={`fa ${
                      showResources ? "fa-chevron-up" : "fa-chevron-down"
                    }`}
                    style={{
                      transition: "transform 0.3s ease",
                      transform: showResources
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    }}
                  ></i>
                </button>

                {/* Summit Submenu */}
                <div
                  className="submenu-container overflow-hidden"
                  style={{
                    maxHeight: showResources ? "300px" : "0",
                    transition:
                      "max-height 0.4s ease-in-out, opacity 0.3s ease",
                    opacity: showResources ? 1 : 0,
                  }}
                >
                  <div className="submenu-items pe-2 ps-3 pt-2">
                    {[
                      { to: "/stories", text: "Stories" },
                      { to: "/testimonials", text: "Testimonials" },
                    ].map((item, index) => (
                      <Link
                        key={index}
                        to={item.to}
                        onClick={() => setIsOpen(false)}
                        className="submenu-link d-block text-start py-2 rounded-2 text-decoration-none"
                      >
                        {item.text}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
              {/* Contact Link */}
              <Link
                to="/contact-us"
                onClick={() => setIsOpen(false)}
                className="mobile-nav-link d-flex justify-content-start gap-3 p-3 mb-3 rounded-3 text-decoration-none"
              >
                <span className="fw-medium">Contact</span>
              </Link>
            </div>
          </nav>

          {/* Modals - only one instance each */}
          {/* Modals controlled by activeModal from Layout */}
          <SignIn
            show={activeModal === "signIn"}
            handleClose={() => setActiveModal(null)}
            openSignUp={() => setActiveModal("signUp")}
            openReset={() => setActiveModal("reset")}
          />
          <Signup
            show={activeModal === "signUp"}
            onClose={() => setActiveModal(null)}
            openSignIn={() => setActiveModal("signIn")}
          />
          <ResetPasswordModal
            show={activeModal === "reset"}
            handleClose={() => setActiveModal(null)}
            openSignIn={() => setActiveModal("signIn")}
          />
        </div>
      </div>
    </header>
  );
};

export default Header;
